export const BACK_BUTTON_DEFAULT_LABEL = 'back-button.default-label';
